var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var AddressFormView = Marionette.View.extend({
    template: require('../../templates/contacts/address-form.html'),

    ui: {
        cancel: '#cancel-address',
        save: '#save-address',
        zip: '#zip',
        address: '#address-input',
        town: '#town',
        state: '#state',
        usage: '#usage'
    },

    regions: {
        stateSelect: '#state-select'
    },

    events: {
        'click @ui.save': 'saveAddress',
        'click @ui.cancel': 'cancel',
        'keyup @ui.zip': 'zipChanged',
        'keyup @ui.address': 'addressChanged',
        'keyup @ui.town': 'townChanged',
        'change @ui.state': 'stateChanged',
        'change @ui.usage': 'usageChanged'
    },

    templateContext: function () {
        return {
            title: this.mode == 'add' ? 'New address' : "Edit address",
            mode: this.mode == 'add' ? 'Add' : "Edit",
            address: this.address,
            addressUsages: Dicts.addressUsages
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'saveAddress', 'zipChanged', 'addressChanged', 'townChanged', 'stateChanged', 'onRender', 'usageChanged', 'cancel');
        this.utils = new CommonUtils();
        if (options) {
            this.address = options.address || {uuid: this.utils.generatedUUID(), source: 'MANUAL'};
            this.address.source = _.isEmpty(this.address.source) ? 'MANUAL' : this.address.source;
            this.mode = options.mode;
        }
    },

    onRender: function () {
        this.ui.usage.selectize({
            allowEmptyOption: false
        });

        this.showStateSelect();
    },

    saveAddress: function () {
        if (_.isEmpty(this.address.address)) {
            notificationsChannel.request('show:notification', 'Address must be set');
            return;
        }

        this.triggerMethod('on:address:saved', {mode: this.mode, address: this.address});
    },

    zipChanged: function (event) {
        this.address.zip = event.target.value;
    },

    addressChanged: function (event) {
        this.address.address = event.target.value;
    },
    stateChanged: function (event) {
        this.address.state = event.target.value;
    },
    townChanged: function (event) {
        this.address.town = event.target.value;
    },
    usageChanged: function (event) {
        this.address.usage = event.target.value;
    },


    showStateSelect: function () {
        var that = this;

        that.showChildView('stateSelect', new RemoteSuggesterView({
            tag: 'state',
            inputId: 'state',
            maxNumberOfElements: 20,
            url: '/api/reference/states/~~~',
            symbolForSearchInUrl: '~~~',
            defaultSelected: that.address.state,
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element;
            },
            classes: ["form-control normal-width"],
            placeholder: "Select state",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            }
        }));
    },

    cancel: function () {
        this.triggerMethod('on:address:action', {mode: 'cancel'});
    }

});

module.exports = AddressFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/contacts/address-form.js
// module id = 259
// module chunks = 0